module.exports = __webpack_public_path__ + "static/mustafa-cbbf4d4b3863b180e662aea9e7829051.jpg";